<template>
    <rkm-modal
        v-if="model"
        ref="Modal"
        title="Opções de impressão"
    >
        <rkm-form
            v-if="model"
            ref="RkmForm"
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-checkbox
                        v-if="form.impressoes.length > 1"
                        :indeterminate="indeterminate"
                        :value="true"
                        @change="checkUncheckAll"
                        v-model="checkedAll"
                    >
                        Todos
                    </rkm-form-checkbox>

                    <rkm-form-checkbox-group
                        :options="form.impressoes"
                        class="mb-0"
                        stacked
                        v-model="model.impressoes"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer>
            <rkm-button @click="close">
                Fechar
            </rkm-button>

            <rkm-button
                :disabled="model.impressoes.length === 0 || !!loading"
                @click="print"
                color="primary"
            >
                Imprimir
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Utils.
import protocoloLaboratorio from '@/utils/exame-laboratorial/impressao/protocolo'
import protocoloLaboratorioExterno from '@/utils/exame-laboratorial/impressao/protocoloExterno'
import protocoloImagem from '@/utils/exame-imagem/impressao/protocolo'
import protocoloImagemExterno from '@/utils/exame-imagem/impressao/protocoloExterno'

// Mixins.
import { error, file, repository, stringCase, object } from '@/mixins'

// Enums.
import impressaoAgendamento from '@/enums/exame-laboratorial/impressaoAgendamento'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({
            loading: 'getLoading',
            cliente: 'getCliente',
            lotacao: 'getLotacao',
            customer: 'getCustomer',
        }),
    },
    created() {

        this.repositories = {
            fila: this.getConectaSusRepository('regulacao.fila'),
            impressao: this.getConectaSusRepository('impressao.regulacao'),
            impressaoAmbulatorio: this.getConectaSusRepository('impressao.ambulatorio'),
            laboratorio: this.getConectaSusRepository('exameLaboratorial.impressoes'),
            imagem: this.getConectaSusRepository('impressao.exameImagem'),
            ambulatorio: this.getConectaSusRepository('impressao.ambulatorio')
        }
    },
    data: () => ({
        checkedAll: false,
        indeterminate: false,
        solicitacao: null,
        form: { impressoes: [] },
        model: { impressoes: [] },
        enums: {
            impressaoAgendamento
        },
        utils: {
            protocoloLaboratorio,
            protocoloImagem,
            protocoloLaboratorioExterno,
            protocoloImagemExterno,
        }
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(solicitacao) {

            this.solicitacao = solicitacao

            this.form.impressoes = [],
            this.model.impressoes = [],

            this.load()
            this.$refs.Modal.show()
        },
        load() {

            this.setLoading()

            this.repositories.fila.getImpressoes({ solicitacao_id: this.solicitacao.id, origem: this.origem })
                .then(({ data }) => this.form.impressoes = data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        checkUncheckAll(value) {

            this.model.impressoes = value ? this.form.impressoes.map(impressao => impressao.value) : []
        },
        print() {

            const items = {
                solicitacao: () => this.repositories.impressao.solicitacaoRegulacao(this.solicitacao.id),
                preparo: () => this.repositories.impressao.preparo(this.solicitacao.id),
                fichaRequisicaoServicoAuxiliarDiagnoseTerapia: () => this.repositories.impressaoAmbulatorio
                    .fichaRequisicaoServicoAuxiliarDiagnoseTerapia(this.solicitacao.ambulatorioAtendimentoId, {
                        regulacao_solicitacao_id: this.solicitacao.id,
                    }),
                servicoAnaliseDiagnosticoTerapiaSolicitacaoExame: () => this.repositories.impressaoAmbulatorio
                    .servicoAnaliseDiagnosticoTerapiaSolicitacaoExame(this.solicitacao.ambulatorioAtendimentoId, {
                        regulacao_solicitacao_id: this.solicitacao.id,
                    }),
                laudoSolicitacaoAutorizacaoProcedimentoAmbulatorial: () => this.repositories.impressaoAmbulatorio
                    .laudoSolicitacaoAutorizacaoProcedimentoAmbulatorial(this.solicitacao.ambulatorioAtendimentoId, {
                        regulacao_solicitacao_id: this.solicitacao.id,
                    }),
                encaminhamento: () => this.repositories.impressaoAmbulatorio
                    .encaminhamento(this.solicitacao.ambulatorioAtendimentoId, {
                        regulacao_solicitacao_id: this.solicitacao.id,
                    }),
                protocoloAgendamentoExameLaboratorial: () => {

                    if (this.solicitacao.prestadorExternoId) {

                        return new Promise((resolve, reject) => {
                            try {
                                const result = this.utils.protocoloLaboratorioExterno.print({
                                    ...this.solicitacao,
                                    cliente: this.cliente.nome,
                                    usuarioLogado: this.lotacao.usuario.nome,
                                    logotipo: this.customer.logotipo,
                                    regulacao: true,
                                });
                                resolve(result);
                            } catch (error) {
                                reject(error);
                            }
                        });
                    } else {

                        return new Promise((resolve, reject) => {
                            try {
                                const result = this.utils.protocoloLaboratorio.print({
                                    ...this.solicitacao.agendamentoData.model.agendamentos[0].impressoes.agendamento[0].data,
                                    cliente: this.cliente.nome,
                                    usuarioLogado: this.lotacao.usuario.nome,
                                    logotipo: this.customer.logotipo,
                                    regulacao: true,
                                });
                                resolve(result);
                            } catch (error) {
                                reject(error);
                            }
                        });
                    }
                },
                protocoloAgendamentoExameImagem: () => {

                    if (this.solicitacao.prestadorExternoId) {

                        return new Promise((resolve, reject) => {
                            try {
                                const result = this.utils.protocoloImagemExterno.print({
                                    ...this.solicitacao,
                                    cliente: this.cliente.nome,
                                    usuarioLogado: this.lotacao.usuario.nome,
                                    logotipo: this.customer.logotipo,
                                    regulacao: true,
                                });
                                resolve(result);
                            } catch (error) {
                                reject(error);
                            }
                        });
                    } else {

                        return new Promise((resolve, reject) => {
                            try {
                                const result = this.utils.protocoloImagem.print({
                                    ...this.solicitacao.agendamentoData[0].impressoes.agendamento[0].data,
                                    cliente: this.cliente.nome,
                                    usuarioLogado: this.lotacao.usuario.nome,
                                    logotipo: this.customer.logotipo,
                                    regulacao: true,
                                });
                                resolve(result);
                            } catch (error) {
                                reject(error);
                            }
                        });
                    }
                },
                protocoloAgendamentoEspecialidade: () => {

                    if (this.solicitacao.prestadorExternoId) {

                        return new Promise((resolve, reject) => {
                            try {
                                const result = this.repositories.ambulatorio.agendamentoExterno(this.solicitacao.id);
                                resolve(result);
                            } catch (error) {
                                reject(error);
                            }
                        });
                    } else {

                        return new Promise((resolve, reject) => {
                            try {
                                const result = this.repositories.ambulatorio.agendamento(this.solicitacao.agendamentoData.agendamentoId);
                                resolve(result);
                            } catch (error) {
                                reject(error);
                            }
                        });
                    }
                },
            }

            this.model.impressoes.forEach(impressao => {

                if (impressao in items) {

                    this.setLoading()

                    items[impressao]()
                        .then(({data, headers}) => this.openFile(data, headers['content-type']))
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                }
            })
        },
        close() {

            this.$refs.Modal.hide()
        },
    },
    mixins: [error, file, repository, stringCase, object],
    watch: {
        'model.impressoes'(value) {
            this.checkedAll = value.length > 0 && value.length == this.form.impressoes.length
            this.indeterminate = value.length > 0 && value.length != this.form.impressoes.length
        },
    },
    props: {
       origem: {
            type: String,
        },
    },
}
</script>